import React, {Component} from 'react';

class OptimizeOpener extends Component {
    render() {
        const {text = 'Optimization Settings'} = this.props;

        return (
            <div className="filters-table-heading">
                <h3 className="filters-table-opener" data-testid="optimization-settings-button">
                    {text}
                </h3>
            </div>
        );
    }
}

export default OptimizeOpener;
